<template>
  <main class="p-logins1" :class="{ mobile_flag: mobile_flag }">
    <!-- 登录部分 -->
    <el-dialog
      :visible.sync="bLogin1"
      :width="mobile_flag ? '98%' : '350px'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="longin_fa">
        <div class="longin" @click="longinMS">{{ this.longinText }}</div>
      </div>
      <main class="login-main">
        <div class="login-mask" v-if="!checkboxVal">
          <div class="text1">
            <p>登录前请先</p>
            <p>阅读并勾选下述协议内容</p>
          </div>
        </div>
        <h1 class="title" v-if="nwxLogin == 5">请重置您的密码</h1>
        <template v-if="nwxLogin == 1"></template>
        <div
          id="login_container"
          :style="{
            height: qrShow ? '400px' : '0px',
            width: '250px',
            textAlign: left,
          }"
        ></div>
        <yzm
          ref="yzm"
          v-if="nwxLogin == 3 || nwxLogin == 4"
          :nwxLogin="nwxLogin"
          v-on:child-say="nwxLogin = 5"
          v-on:close="loginClose"
          :yzmFalse="yzmFalse"
        ></yzm>
        <wjmm ref="wjmm" v-if="nwxLogin == 5"></wjmm>
        <!-- 完善个人信息 -->
        <BindWx ref="BindWx" v-if="nwxLogin == 6"></BindWx>
      </main>
      <div class="footer" v-if="nwxLogin != 5 && nwxLogin != 6">
        <input
          type="checkbox"
          class="checked-xy"
          id="agree-register-protocol"
          value="checkboxVal"
          v-model="checkboxVal"
        />
        阅读并同意
        <a style="color: #ff8488; cursor: pointer" @click="bLogin2 = true"
          >《服务协议》</a
        >
        和
        <a style="color: #ff8488; cursor: pointer" @click="bLogin3 = true"
          >《隐私协议》</a
        >
      </div>
    </el-dialog>
    <!-- 服务协议 start -->
    <el-dialog
      :visible.sync="bLogin2"
      :width="mobile_flag ? '98%' : '426px'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="bLogin1 = true"
    >
      <a class="iconfont back" @click="bLogin2 = false">&#xe653;</a>
      <main class="greement">
        <h1 class="title">海星云平台服务协议</h1>
        <div class="xieyi-box">
          <div class="xieyi">
            <font>星瀛科技（北京）有限公司</font>
            <br />
            <font>关于海星云平台的使用及付费服务协议</font>
            <br />
            <br />导言：
            <br />欢迎您使用星瀛科技（北京）有限公司平台提供的网站、软件及服务！
            星瀛科技（北京）有限公司（以下称为“星瀛科技”）系网站www.haixingcloud.com及海星云平台的运营商，为保障用户正常使用星瀛科技（北京）有限公司（以下简称
            “星瀛科技”）提供的网站、软件及服务（以下成为“本服务”），用户需阅读并遵守《星瀛科技关于海星云平台的的使用及付费服务协议》（以下简称“本协议”）。
            用户在使用星瀛科技提供的各项服务之前，应仔细阅读本协议，如用户不同意本服务协议及/或随时对其的修改，请停止使用星瀛科技提供的服务。
            <br />同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务(以下称“网络服务”)，为获得网络服务，服务使用人(以下称“用户”)同意本协议的全部条款并按照页面上的提示完成全部的注册程序。
            <br />
            <br />
            <p style="color: #ff8488">
              用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。
              用户的使用、登录等行为即视为您已阅读并同意本协议的约束。
            </p>
            <br />本协议下的条款可由星瀛科技随时变更，用户须定期审阅本协议。协议条款一旦发生变动，星瀛科技将会在本页面进行更新，并在星瀛科技相关的页面上提示变更内容。变更后的协议一经公布即有效代替原来的协议。用户如不同意星瀛科技对本协议所作的任何变更，应立即停止使用星瀛科技提供的星瀛科技网站、软件及服务。如用户在本协议变更后继续使用星瀛科技网站、软件及服务，即视作用户已完全同意变更后的协议。用户可随时在本页面查阅最新付费服务及充值规则。
            <br />用户有违反本协议的任何行为时，星瀛科技有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。
            <br />注意：您需达到18周岁或者达到您所在地区的法定成年年龄，方可使用我们的产品或服务。
            <br />一、定义 <br />1.1星瀛科技：指星瀛科技（北京）有限公司。
            <br />1.2网站、软件及服务：指星瀛科技提供的网站、软件及服务。
            <br />1.3用户：指启用、浏览或上传数据至星瀛科技海星云平台服务的用户，在本协议中更多地称为“您”。
            <br />1.4其他用户：指除用户本人外与星瀛科技平台服务相关的其他星瀛科技用户。
            <br />1.5法律法规：指用户所属/所处地区、国家现行有效的法律、行政法规、司法解释、地方法规、地方规章、部门规章及其他规范性文件以及对于该等法律法规的不时修改和补充，以及相关政策规定等
            <br />二、协议的范围
            <br />2.1本协议是您与星瀛科技之间关于您在下载、安装、使用、复制本平台、软件和网站中涉及付费服务和充值规则等相关事宜所订立的协议。
            <br />2.2本协议内容同时包括星瀛科技可能不断发布的关于付费服务和充值规则的相关协议、服务声明、业务规则及公告指引等内容（以下统称为“专项规则”）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
            <br />三、用户身份信息验证
            <br />3.1您在申请海星云账号过程中，需要填写一些必要的信息，请保持这些信息的及时更新，以便星瀛科技向您提供帮助，或更好地为您提供服务。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整或不准确，则可能无法使用服务或在使用过程中受到限制。
            <br />3.2星瀛科技与用户一同致力于个人信息的保护，保护用户个人信息是星瀛科技的一项基本原则。未经您的同意，星瀛科技不会向星瀛科技以外的任何公司、组织或个人披露您的个人信息，但法律法规另有规定的除外。
            <br />四、使用规则
            <br />4.1用户承诺以其真实身份注册成为星瀛科技的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法令规定和本协议约定对所提供的信息承担相应的法律责任。星瀛科技有权审查用户注册所提供的身份信息是否真实、有效。用户以其真实身份注册成为星瀛科技用户后，需要修改所提供的个人身份资料信息的，星瀛科技应当及时、有效地为其提供该项服务。若用户所提供的资料与事实不符或所提供的资料已变更而未更新或有任何误导之嫌导致星瀛科技无法为用户提供或进一步提供服务，星瀛科技不因此承担任何责任。
            <br />4.2用户注册成功后，星瀛科技将给予每个用户一个用户账号及相应的密码。该用户账号和密码由用户负责保管。用户有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码，并对登录后所持账号产生的行为依法享有权利和承担责任。星瀛科技应积极地采取技术与管理等合理措施保障用户账号的安全、有效。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给用户和他人的民事权利造成损害的，应当承担由此产生的法律责任。鉴于网络服务的特殊性，星瀛科技无义务审核是否用户本人使用该组账号及密码，仅审核账号及密码是否与数据库中保存的一致，只要任何人输入的账号及密码与数据库中保存的一致，即可凭借该组账号及密码登录并获得网络服务，所以即使用户认为其所有的账号登录行为并非其本人所为，星瀛科技将不承担因此而产生的任何责任。
            <br />4.3用户发现其账号或密码被他人非法使用或有使用异常的情况的，应及时根据星瀛科技公布的处理方式通知星瀛科技，并有权通知星瀛科技采取措施暂停该账号的登录和使用,用户可发送相关信息至
            service@starvictory.com或直接联系客服人员，进行举证通知。星瀛科技在收到用户要求采取措施暂停其账号登录和使用的通知后，应当要求用户提供并核实与其注册身份信息相一致的个人有效身份信息。星瀛科技核实用户所提供的个人有效身份信息与所注册的身份信息相一致的，应当及时采取措施暂停用户账号的登录和使用。用户提供其个人有效身份证件与所注册的身份信息一致的，有权及时采取措施暂停用户账号的登录和使用。用户没有提供其个人有效身份证件或者用户提供的个人有效身份证件与所注册的身份信息不一致的，星瀛科技有权拒绝用户前述请求，用户应当自行承担相应损失。
            <br />4.4用户为了维护其合法权益，向星瀛科技提供与所注册的身份信息相一致的个人有效身份信息时，星瀛科技应当为用户提供账号注册人证明、原始注册信息等必要的协助和支持，并根据需要向有关行政机关和司法机关提供相关证据信息资料。
            <br />4.5用户同意接受星瀛科技通过电子邮件或其他方式向用户发送的商品促销或其他相关商业信息。
            <br />4.6用户在使用星瀛科技服务过程中，必须遵循以下原则：
            <br />4.6.1遵守中国有关的法律和法规；
            <br />4.6.2遵守所有与网络服务有关的网络协议、规定和程序；
            <br />4.6.3发现任何非法使用用户账号或账号出现安全漏洞的情况，应立即通告星瀛科技；
            <br />4.7禁止用户在接受网络服务过程中进行以下侵害行为，包括但不限于：
            <br />4.7.1违反宪法确定的基本原则的；
            <br />4.7.2危害国家统一、主权和领土完整的；
            <br />4.7.3泄露国家秘密、危害国家安全或者损害国家荣誉和利益的；
            <br />4.7.4煽动民族仇恨、民族歧视，破坏民族团结，或者侵害民族风俗、习惯的；
            <br />4.7.5宣扬邪教、迷信的；
            <br />4.7.6散布谣言，扰乱社会秩序，破坏社会稳定的；
            <br />4.7.7宣扬淫秽、色情、赌博、非法彩票、暴力，或者教唆犯罪的；
            <br />4.7.8侮辱、诽谤他人，侵害他人合法权益的；
            <br />4.7.9违背社会公德的；
            <br />4.7.10使用外挂、进行比特币等数字货币挖矿等违约、违规、违法、违反公序良俗、侵犯星瀛科技或任何第三方之权益等；
            <br />4.7.11有法律、行政法规和国家规定禁止的其他内容的。
            <br />4.8禁止用户进行以下侵害网络服务安全性的行为，包括但不限于：
            <br />4.8.1以任何形式违反诚实信用原则，直接或间接采取组织、教唆、窃取、占有、使用、捡取、购买、转卖等手段侵犯任何第三方拥有使用权的账号、角色、虚拟货币、虚拟物品、虚拟道具等权益；
            <br />4.8.2以任何积极或消极的形式协助他人侵犯第三方权益的；
            <br />4.8.3禁止用户利用网络服务无关的行为，包括但不限于：
            <br />4.8.3.1为任何非法目的及与星瀛科技提供服务或产品未有直接关系而使用网络服务系统；包括但不限于买卖号、角色、虚拟货币、虚拟道具、虚拟物品，宣传赌博、非法彩票等；
            <br />4.8.3.2未经星瀛科技授权访问或试图访问与星瀛科技提供的网络服务相关的任何账户、计算机或网络；
            <br />4.8.3.3未经星瀛科技授权利用星瀛科技提供的相关网络服务以任何方式收集任何其它用户的信息，包括但不限于用户的个人身份信息和通讯信息；
            <br />4.8.3.4接收或下载由其他星瀛科技用户传输的用户所知道或应当知道不能以此方式合法传播的任何材料；
            <br />4.8.3.5利用星瀛科技提供的相关网络服务进行任何可能对互联网的正常运转造成不利影响的行为，包括但不限于以任何方式传输含有计算机病毒、破坏性程序的文件或其他任何可能对他人计算机或互联网的正常运转造成不利影响的软件或程序；
            <br />4.8.3.6利用星瀛科技提供的相关网络服务传输任何骚扰性的、中伤他人的、辱骂性的、恐吓性的、庸俗淫秽的或其他任何非法的信息资料；
            <br />4.8.3.7利用星瀛科技提供的相关网络服务进行任何不利于星瀛科技的行为；
            <br />4.8.3.8利用星瀛科技服务系统进行任何洗钱、购买和销售非法取得虚拟货币等违法行为；
            <br />4.8.3.9就星瀛科技及合作商业伙伴的服务、产品、业务咨询应采取相应机构提供的沟通渠道，在公众场合发布有关星瀛科技及相关服务的负面宣传。
            <br />4.9用户使用根据本协议获得的用户账号和密码登录星瀛科技的网站或接受其他星瀛科技提供的服务项目时，应遵守该网站或服务项目的相关服务协议及使用守则，用户登录上述网站或接受上述服务项目时即视为对相关服务协议及使用守则的接受。
            <br />五、用户信息保护
            <br />5.1保护用户（特别是未成年人）的隐私是星瀛科技的一项基本政策，因此，若父母（监护人）希望未成年人（尤其是十岁以下子女）得以使用本服务，必须以父母（监护人）名义申请注册，在接受本服务时，应以法定监护人身份加以判断本服务是否符合于未成年人。
            <br />5.2在不透露单个用户隐私资料的前提下，星瀛科技有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。尽管对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。
            <br />5.3未经用户许可星瀛科技不得向任何第三方公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：
            <br />5.3.1用户或用户监护人授权星瀛科技披露的；
            <br />5.3.2有关法令要求星瀛科技披露的；
            <br />5.3.3司法机关或行政机关基于法定程序要求星瀛科技提供的；
            <br />5.3.4星瀛科技为了维护自己合法权益而向用户提起诉讼或者仲裁时；
            <br />5.3.5应用户监护人的合法要求而提供用户个人身份信息时；
            <br />5.3.6为维护社会公众的利益。 <br />六、付费服务及充值规则
            <br />6.1您理解并同意，星瀛科技有权免费或要求付费提供本服务；本服务收取的充值金额是星瀛科技为了向最终用户收取互联网增值服务使用费，而提供的一种通用的收费渠道或计费方式。该充值金额不能用于本服务以外的任何产品或服务。
            <br />6.2您理解并同意，星瀛科技有权自行决定并不时修订本服务相关的收费标准和规则，该类标准及规则一经发布即生效，并构成本协议的有效组成部分。星瀛科技可能根据实际需要对收费服务的收费标准、方式进行修改和变更，也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，星瀛科技将在相应服务页面进行通知或公告。如您不同意前述标准、规则及其修订，您有权停止使用本服务。您继续使用本服务即视为您同意相关内容。
            <br />6.3本平台的部分服务是以收费方式提供的，如您使用收费服务，请遵守相关规则。星瀛科技会在相关页面上做出提示，如果您拒绝支付该等费用，则不能使用相应的网络服务。
            <br />6.4星瀛科技将有权决定所提供服务的资费标准和收费方式，星瀛科技可能会就不同的服务制定不同的资费标准和收费方式，也可能按照星瀛科技所提供的服务的不同阶段确定不同的资费标准和收费方式。
            <br />6.5充值
            <br />6.5.1在本平台支付系统中，用户通过所用客户端（包括但不限于手机、网站及其他第三方支付渠道）相应支付方式（具体支付方式请见充值页面）为其账号充值所直接获得的虚拟货币即为“海星点”，仅可在本平台使用。1海星点=2元人民币。
            <br />6.5.2本平台支付系统会不时更新发布活动，包括但不限于充值人民币送海星点
            <br />6.5.3海星点可以用于支付接入本平台支付系统的所有互联网应用及内容（包括第三方）的费用。一旦用户用其账号进入第三方企业的服务系统，则支付系统会自动通过和第三方企业的技术合作，将该账号所剩余的海星点以可以消费的该第三方系统自身的结算工具显示给用户；一旦用户退出该第三方服务系统，则在本平台支付系统中仍然可以显示尚未消费的海星点。
            <br />6.5.4用户理解并知晓，星瀛科技不提供用户间交易海星点的平台化服务。用户间交易海星点构成对本协议的违反，星瀛科技有权在未经通知的情况下，采取相应适当措施，以确保星瀛科技不提供用户间交易海星点的平台化服务。
            <br />6.5.5用户理解并同意，充值产品虚拟货币不适用无理由退换，充值一旦成功，充值即确定完成，星瀛科技将不提供任何更改、修正服务。用户不得以消费完成后账户内仍有剩余海星点为由要求退费。
            <br />6.5.6当用户在本平台进行充值时，用户必须仔细确认自己的账号及信息，若因为用户自身操作不当、不了解或未充分了解充值计费方式等因素造成充错账号、错选充值种类等情形而损害自身权益，不得因此要求星瀛科技作任何补偿或赔偿。
            <br />6.5.7用户在充值时使用第三方支付企业提供的服务的，应当遵守与该第三方的各项协议及其服务规则；在使用第三方支付服务过程中用户应当妥善保管个人信息，包括但不限于银行卡账号、密码、验证码等；用户同意并确认，星瀛科技对因第三方支付服务产生的纠纷不承担任何责任。
            <br />6.5.8若因违反本协议条款，导致账号被冻结及/或终止使用的用户，不得因此要求星瀛科技作任何补偿或赔偿。
            <br />6.5.9若因本平台充值系统自身充值故障原因造成用户充值失实，在星瀛科技恢复、存有有效数据和用户提供合法有效凭证的情况下，星瀛科技将根据用户充值情况做出变动及补救措施。
            <br />6.5.9.1因本平台充值系统自身故障原因，造成系统充值额小于用户实际充值额的，星瀛科技予以补其差额。
            <br />6.5.9.2因本平台充值系统自身故障原因，造成系统充值额大于用户实际充值额的，星瀛科技有权追回差额。
            <br />6.5.9.3海星点是在本平台专用的虚拟货币，用于包括但不限于游玩消耗等网络服务。鉴于本平台提供的网络服务或商品性质特殊，因此，使用海星点在本平台上购买的网络服务或商品属于不宜退货的商品，不适用无理由退换规定。
            <br />6.5.9.4用户理解并同意，您使用帐户内的海星点订阅产品一旦成功，星瀛科技将不提供任何订单更改、修正服务。非经星瀛科技同意，用户订购付费产品并已支付的海星点，将无法退还；用户订购付费产品并已支付的海星点亦不会因本平台提供的服务中止、中断或付费产品下架而退还。
            <br />6.5.10 海星云【海星点账户】和【赠点账户】说明
            <br />6.5.10.1海星云实际充值金额对应的海星点（2元=1海星点）为【海星点账户】。
            <br />6.5.10.2【海星云赠点账户】为赠送的海星点数，包括但不限于充值赠送、活动赠送、签到赠送、用户转赠、海星云官方补偿点数等。
            <br />6.5.10.3海星云赠点。海星云赠点有效期为1年，充值后赠点可长期有效。
            <br />6.5.10.4海星云平台上的转账功能仅限于使用海星点账户中的点数，赠点账户点数无法转赠他人。同时，转账的点数视为赠送点数，进入对方的赠点账户。
            <br />6.5.10.5用户理解并同意，转赠海星点及赠点不适用无理由退换，转赠一旦成功，即确定完成转赠，海星云将不提供任何更改、修正服务。
            <br />6.5.10.6当用户在本平台进行海星点转赠时，用户必须仔细确认转赠的账号及信息，若因为用户自身操作不当、不了解或未充分了解海星点转赠说明等因素造成赠错账号、错填赠送点数等情形而损害自身权益，不得因此要求星瀛科技作任何补偿或赔偿。
            <br />6.5.10.7海星云【邀请提现】活动中，被邀请用户充值点数的部分海星点将充进其赠点账户（详情请参阅vip等级说明）。
            <br />11当用户在本平台进行转账时，用户必须仔细确认转赠的账号及信息，若因为用户自身操作不当、不了解或未充分了解转账说明等因素造成赠错账号、错填赠送点数等情形而损害自身权益，不得因此要求星瀛科技作任何补偿或赔偿。
            <br />1海星云【邀请提现】活动中邀请用户获得的提现金额由被邀请充值用户转赠而得，即充值用户中海星点账户属提现金额部分，其对应的海星点数转到充值用户的赠点账户中（2元=1海星点）
            <br />七、未成年人保护
            <br />7.1星瀛科技非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用本服务前，应事先取得您监护人的书面同意。
            <br />7.2依据我国相关法律对于未成年人民事行为效力的规定，为保护未成年人在使用本平台过程中的权益，未成年人在进行星瀛科技充值及消费等行为前，应事先取得您监护人的书面同意。若完成充值行为后，未成年人和/或其监护人主张该充值行为无效的，星瀛科技支持退还相应充值金额，请与本平台客服联系申请退还充值金额。若完成充值行为后进行消费，未成年人和/或其监护人主张该消费行为无效的，星瀛科技不承担退还相应消费金额的责任，亦不得因此要求星瀛科技作任何补偿或赔偿。
            <br />八、通知和送达
            <br />8.1本协议项下所有的通知均可通过重要页面公告、电子邮件、短信或常规的信件传送等方式进行；该通知于发送之日视为已送达收件人。
            <br />九、免责声明 <br />9.1星瀛科技通行证所有者不保证以下事宜：
            <br />9.1.1本服务将符合您的要求；
            <br />9.1.2本服务将不受干扰、及时提供、安全可靠或不会出错。
            <br />十、拒绝提供担保
            <br />10.1用户个人对网络服务的使用承担风险。星瀛科技对以下事宜不作任何类型的担保，不论是明确的或隐含的：
            <br />10.1.1本协议项下星瀛科技提供的相关网络服务将符合用户的要求；
            <br />10.1.2本协议项下星瀛科技提供的相关服务将不受不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、电信部门原因及其他任何网络、技术、通信线路等外界或人为因素的影响；
            <br />10.1.3安装、复制、访问网站、充值、运行客户端软件或以其它方式使用“网络游戏”及/或接受星瀛科技提供的相关服务与任何其他软件不存在任何冲突；
            <br />10.1.4通过星瀛科技网站、网络游戏官方网站及其他相关网络上的链接和标签所指向的第三方的商业信誉及其提供服务的质量。
            <br />十一、服务变更、中断或终止
            <br />11.1如因系统维护或升级的需要而需暂停网络服务，星瀛科技将尽可能事先进行通告。
            <br />11.2
            用户在接受星瀛科技提供的服务时实施不正当行为的，星瀛科技有权终止对用户提供服务，进行封号处理，并在情形严重时，将相关信息移交公安机关。该不当行为包括但不限于使用外挂、进行比特币等数字货币挖矿等违约、违规、违法、违反公序良俗、侵犯星瀛科技或任何第三方之权益等。
            <br />11.3用户在接受星瀛科技服务时实施本协议中有明确约定或属于星瀛科技事先明确告知的应被终止服务的禁止性行为的，星瀛科技有权终止对用户提供服务。
            <br />11.4用户提供虚假注册身份信息，或实施违反本协议的行为，星瀛科技采取中止措施应当通知用户并告知中止期间，中止期间应该是合理的，中止期间届满星瀛科技应当及时恢复对用户的服务。
            <br />11.5用户利用星瀛科技服务进行洗钱、预付卡套现、购买和销售非法取得虚拟货币等违法行为的，星瀛科技有权在不事先通知用户的情况下中止或终止部分或全部网络服务的权利。
            <br />十二、客户服务
            <br />12.1如果您对星瀛科技采取的账号的限制、冻结或终止等任何措施有异议或在使用海星云的过程中有其他问题的，均可联系星瀛科技客户服务部门（service@starvictory.com），我们会给予您必要的帮助。
            <br />十三、其他
            <br />13.1您使用本平台即视为您已阅读并同意受本协议的约束。星瀛科技有权在必要时修改本协议条款。您可以在本平台的最新版本中查阅相关协议条款，星瀛科技亦会在本平台内显著地方公示。本协议条款变更后，如果您继续使用本平台，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本平台。
            <br />13.2本协议签订地为中华人民共和国北京市海淀区。
            <br />13.3本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）
            <br />13.4若您和星瀛科技之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您应同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
            <br />13.5本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
            <br />13.6本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
            <br />（正文完） <br />特 别 声 明
            <br />鉴于：我国《合同法》第39条规定：采用格式条款订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。
            <br />星瀛科技在此依法做出特别声明如下：
            <br />星瀛科技采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中星瀛科技以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款（需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”等形式用语的条款），该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款。
            <br />用户如有任何需要说明条款的要求，请立即停止使用服务，同时立即发送邮件至本平台官方客服人员（邮箱地址：service@starvictory.com），若用户未发送内含说明条款要求的邮件至本平台官方客服人员而选择同意该协议，则双方在此确认星瀛科技已依法履行了根据用户要求对相关条款进行说明的法定义务，星瀛科技已给予用户充足的时间与充分的选择权来决定是否缔结本协议。
            <br />用户确认已经充分阅读本协议所有条款，明确理解以上协议条款的含义，完全注意并同意了本协议所有条款的合法性及有效性。
          </div>
        </div>
      </main>
    </el-dialog>
    <!-- 服务协议 end -->
    <!-- 隐私协议 start-->
    <el-dialog
      :visible.sync="bLogin3"
      :width="mobile_flag ? '98%' : '426px'"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="bLogin1 = true"
    >
      <a class="iconfont back" @click="bLogin2 = false">&#xe653;</a>
      <main class="greement">
        <h1 class="title">海星云平台隐私协议</h1>
        <div class="xieyi-box">
          <div class="xieyi">
            <font>星瀛科技（北京）有限公司</font>
            <br />
            <font>关于海星云平台的隐私政策协议</font>
            <br />
            <br />导言：
            <br />欢迎您使用星瀛科技（北京）有限公司平台提供的网站、软件及服务！
            星瀛科技（北京）有限公司（以下称为“星瀛科技”）系网站www.haixingcloud.com及海星云平台的运营商，为保障用户正常使用星瀛科技（北京）有限公司（以下简称
            “星瀛科技”）提供的网站、软件及服务（以下成为“本服务”），海星云服务平台（以下统称“本平台”）所提供的各项服务的所有权和运作权均归于星瀛科技所有。用户需阅读并遵守《星瀛科技关于海星云平台的隐私政策》（以下简称“本协议”）。
            用户在使用星瀛科技提供的各项服务之前，应仔细阅读本协议，如用户不同意本服务协议及/或随时对其的修改，请停止使用星瀛科技提供的服务。
            <br />同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务(以下称“网络服务”)，为获得网络服务，服务使用人(以下称“用户”)同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在进行注册程序过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。
            <br />
            <br />
            <p style="color: #ff8488">
              用户的使用、登录等行为即视为您已阅读并同意本协议的约束。
            </p>
            <br />本协议下的条款可由星瀛科技随时变更，用户须定期审阅本协议。协议条款一旦发生变动，星瀛科技将会在本页面进行更新，并在星瀛科技相关的页面上提示变更内容。变更后的协议一经公布即有效代替原来的协议。用户如不同意星瀛科技对本协议所作的任何变更，应立即停止使用星瀛科技提供的星瀛科技网站、软件及服务。如用户在本协议变更后继续使用星瀛科技网站、软件及服务，即视作用户已完全同意变更后的协议。用户可随时在本页面查阅最新付费服务及充值规则。
            <br />用户有违反本协议的任何行为时，星瀛科技有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。
            <br />
            <br />注意：您需达到18周岁或者达到您所在地区的法定成年年龄，方可使用我们的产品或服务。
            <br />
            <br />本平台承诺严格遵守法律法规，遵循以下隐私保护原则，为用户提供更加安全、可靠的服务:
            <br />一、用户信息收集
            <br />个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本平台仅会出于本政策所述的以下目的，收集和使用用户的个人信息:
            <br />1.1 有关个人身份的信息
            <br />当用户使用海星云服务时，本平台可能收集和汇总或要求用户提供有关个人身份的信息，例如:
            <br />1.1.1 用户向本平台提供的信息
            <br />>当用户在海星云注册账户及在使用海星云或本平台提供的相关服务时填写或提交的信息：联系方式等。
            <br />1.1.2 从第三方平台获取的用户信息
            <br />当用户选择使用第三方平台（如微信等）登录海星云时，用户需将第三方的账号信息提供给本平台，但本平台仅根据第三方返回的验证结果来判断用户的身份，不会获取到用户的密码等隐私信息，但本平台可以根据第三方的规定及用户的授权，获得用户在第三方的个性化信息（如头像，昵称等）。
            <br />1.2
            开展内部数据分析和研究，第三方SDK统计服务，改善本平台的产品或服务。
            <br />本平台收集数据是根据用户与本平台的互动和用户所做出的选择，包括用户的隐私设置以及使用的产品和功能。本平台收集的数据可能包括SDK/API/JS代码版本等。
            <br />本平台收集这些信息主要是为了所有用户能够更容易、更满意地使用海星云。当本平台要将信息用于本协议未载明的其它用途或者将基于特定目的收集而来的信息用于其他目的时，会事先征求用户的同意。
            <br />1.3
            为了确保透明度并赋予用户对个人隐私的控制权，本平台在此详细阐述了我们对用户个人信息的收集和使用原则。此举旨在支持和增强用户体验，同时确保个人信息的安全和隐私得到妥善管理。
            <br />1.3.1收集信息的核心目标包括但不限于：
            <br />优化服务质量：通过不断研发和改良产品，我们致力于为用户提供更加个性化和高效的服务。
            <br />账户保护：严格的身份验证和账户监控机制以防止未授权访问和欺诈行为。
            <br />功能实现：确保平台的关键功能得以正常运作，以便用户无缝享受服务。
            <br />1.3.2我们采取多种方式收集信息，其中包括：
            <br />自动追踪：便捷地记录用户的来源路径、访问顺序和设备细节（如IP地址、访问时间等）。
            <br />用户输入：在注册和登录过程中，用户可主动提供诸如昵称、联系方式和电子邮箱等信息。
            <br />设备数据：通过用户授权，我们获取设备型号、操作系统信息和唯一标识符等关键数据。
            <br />第三方数据：当用户选择通过外部平台账户登录时，我们会接收相关的个性化信息，如用户头像和昵称。
            <br />分析工具：利用先进的分析技术（SDK/API/JS代码）来洞察用户使用习惯，如浏览器类型和IP地址。
            <br />活动反馈：在用户参与平台活动时所提交的信息，例如收货地址，均被谨慎处理。
            <br />我们深刻认识到个人信息的敏感性，并承诺采取一切必要措施来防止信息的未授权访问、处理或意外丢失。我们将恪守法律规定，不会无端延长个人信息的保存期限，并确保所有个人信息的处理都符合相关法律法规的要求。
            收集这些信息主要是为了所有用户能够更容易、更满意地使用海星云。当本平台要将信息用于本协议未载明的其它用途或者将基于特定目的收集而来的信息用于其他目的时，会事先征求用户的同意。
            <br />二、 用户信息的收集与使用
            <br />为了提高服务质量，本平台可能把用户的信息用于下列用途：
            <br />2.1
            向用户提供服务，包括但不限于语音通信、星瀛科技各项推广活动如排行榜、抽奖活动等。
            <br />2.2
            用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保本平台向用户提供的产品和服务的安全性。同时，依照相关法律法规的要求或者特定功能及服务需要，用户在使用特定功能及服务前，可能需要用户提供其他信息（例如姓名、身份证及其他身份证明信息）。如果用户不提供上述信息，本平台将不能向用户提供相关的功能及服务。
            <br />2.3
            向用户推荐用户可能感兴趣的内容，包括但不限于向用户发出系统公告，站内消息等，通过系统向用户推荐展示各种特色活动信息或者在征得用户同意的情况下与本平台的合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息。
            <br />2.4
            使本平台更加了解用户如何接入和使用本平台的服务，从而针对性地回应用户的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示或对用户作出其他方面的回应。
            <br />2.5 软件认证或软件升级等。 <br />2.6
            让用户参与有关本平台产品和服务的调查。 <br />2.7
            经用户许可的其他用途。 <br />2.8 征得授权同意的例外 <br />2.9
            根据相关法律法规规定，以下情形中收集用户的信息无需征得用户的授权同意：
            <br />2.9.1 与国家安全、国防安全有关的； <br />2.9.2
            与公共安全、公共卫生、重大公共利益有关的； <br />2.9.3
            与犯罪侦查、起诉、审判和判决执行等有关的； <br />2.9.4
            出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到用户本人同意的；
            <br />2.9.5 所收集的信息是用户自行向社会公众公开的； <br />2.9.6
            从合法公开披露的信息中收集信息的，如合法的新闻报道、政府信息公开等渠道；
            <br />2.9.7 根据用户的要求签订合同所必需的； <br />2.9.8
            用于维护本平台服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；
            <br />2.9.9 为合法的新闻报道所必需的； <br />2.9.10
            学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的信息进行去标识化处理的；
            <br />2.9.11 法律法规规定的其他情形。 <br />2.10
            在符合用户和本平台之间的协议约定条件及国家相关法律法规规定的情况下，用户的本平台帐号可能被注销或删除。当帐号注销或被删除后，与该帐号相关的全部服务资料和数据将依照协议约定删除或处理，但法律法规另有规定的除外。本平台不会向任何无关第三方提供、出售、出租、分享或交易用户的个人信息，除非事先得到用户的许可，或该第三方和本平台（含本平台关联公司）单独或共同为用户提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料。
            <br />2.11
            本平台亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何本平台用户如从事上述活动，一经发现，本平台有权立即终止与该用户的服务协议。
            <br />2.12
            为服务用户的目的，本平台可能通过使用用户的个人信息，向用户提供其感兴趣的信息，包括但不限于向用户发出产品和服务信息，或者与本平台合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息（后者需要用户的事先同意）。
            <br />三、 COOKIES、日志档案和WEBBEACON的收集和使用 <br />3.1
            本平台或本平台的第三方合作伙伴可能通过COOKIES和WEB
            BEACON获取和使用用户的信息，并将该等信息储存为日志信息。 <br />3.2
            通过使用COOKIES，本平台向用户提供简单易行并富个性化的网络体验。一个COOKIES是少量的数据，它们从一个网络服务器送至用户的浏览器并存在计算机硬盘上。本平台使用COOKIES是为了让其用户可以受益。比如，为使得虚拟社区的登录过程更快捷，用户可以选择把用户名存在一个COOKIES中。这样下次当用户要登录本平台的服务时能更加方便快捷。
            COOKIES能帮助本平台确定用户连接的页面和内容，用户在特定服务上花费的时间和用户所选择的服务。
            <br />3.3
            COOKIES使得本平台能更好、更快地为用户服务，并且使用户在服务上的经历更富个性化。然而，用户应该能够控制COOKIES是否以及怎样被你的浏览器接受。请查阅用户的浏览器附带的文件以获得更多这方面的信息。
            <br />3.4 本平台和第三方合作伙伴可能通过COOKIES和WEB
            BEACON收集和使用用户的信息，并将该等信息储存。 <br />3.5
            本平台使用自己的COOKIES和WEBBEACON，用于以下用途： <br />3.5.1
            记住用户的身份。例如：COOKIES和WEB
            BEACON有助于本平台辨认用户作为本平台的注册用户的身份，或保存用户向本平台提供有关用户的喜好或其他信息；
            <br />3.5.2 分析用户使用本平台服务的情况。本平台可利用COOKIES和WEB
            BEACON来了解用户使用服务进行什么活动、或哪些服务或服务最受欢迎；
            <br />3.5.3 广告优化。COOKIES和WEB
            BEACON有助于本平台根据用户的信息，向用户提供与用户相关的广告而非进行普遍的广告投放。
            <br />3.6 本平台为上述目的使用COOKIES和WEB
            BEACON的同时，可能将通过COOKIES和WEB
            BEACON收集的非个人身份信息汇总提供给广告商和其他伙伴，用于分析用户和其他用户如何使用服务并用于广告服务。
            <br />3.7 服务上可能会有广告商和其他合作方放置的COOKIES和WEB
            BEACON。这些COOKIES和WEB
            BEACON可能会收集与用户相关的非个人身份信息，以用于分析用户如何使用该等服务、向用户发送用户可能感兴趣的广告，或用于评估广告服务的效果。这些第三方COOKIES和WEB
            BEACON收集和使用该等信息不受本《隐私政策》约束，而是受到其自身的个人信息保护声明约束，本平台不对第三方的COOKIES或WEB
            BEACON承担责任。 <br />3.8
            用户可以通过浏览器或用户选择机制拒绝或管理COOKIES或WEB
            BEACON。但请用户注意，如果用户停用COOKIES或WEB
            BEACON，本平台有可能无法为用户提供最佳的服务体验，某些服务也可能无法正常使用。同时，用户仍然将收到广告，只是这些广告与用户的相关性会降低。
            <br />四、 可能分享、转让或披露的用户信息 <br />4.1
            分享。除以下情形外，未经用户同意，本平台不会与本公司之外的任何第三方分享用户的信息：
            <br />4.1.1
            向用户提供本平台的服务。本平台可能向合作伙伴及其他第三方分享用户的信息，以实现用户需要的核心功能或提供用户需要的服务，例如：向物流服务商提供对应的订单信息；
            <br />4.1.2
            维护和改善本平台的服务。本平台可能向合作伙伴及其他第三方分享用户的信息，以帮助本平台为用户提供更有针对性、更完善的服务，例如：代表本平台发出电子邮件或推送通知的通讯服务提供商等；
            <br />4.1.3
            实现本《隐私政策》第二条“本平台如何收集和使用信息”部分所述目的；
            <br />4.1.4
            履行本平台在本《隐私政策》或本平台与用户达成的其他协议中的义务和行使本平台的权利；
            <br />4.1.5
            向委托本平台进行推广的合作伙伴等第三方共享，但本平台仅会向这些委托方提供推广的覆盖面和有效性的信息，而不会提供可以识别用户身份的信息，例如姓名电话号码或电子邮箱；或者本平台将这些信息进行汇总，以便它不会识别用户个人。比如本平台可以告知该委托方有多少人看了他们的推广信息或在看到这些信息后购买了委托方的商品，或者向他们提供不能识别个人身份的统计信息，帮助他们了解其受众或顾客。
            <br />4.1.6
            在法律法规允许的范围内，为了遵守法律、维护本平台及本平台的关联方或合作伙伴、用户或其他用户或社会公众利益、财产或安全免遭损害，比如为防止欺诈等违法活动和减少信用风险，本平台可能与其他公司和组织交换信息。不过,这并不包括违反本《隐私政策》中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的信息。
            <br />4.1.7 用户合法需求，协助处理用户与他人的纠纷或争议；
            <br />4.1.8 应用户的监护人合法要求而提供用户的信息； <br />4.1.9
            根据与用户签署的单项服务协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供；
            <br />4.1.10 基于学术研究而提供； <br />4.1.11
            基于符合法律法规的社会公共利益而提供。
            <br />本平台仅会出于合法、正当、必要、特定、明确的目的共享用户的信息。对本平台与之共享信息的公司、组织和个人，本平台会与其签署严格的保密协定，要求他们按照本平台的说明、本《隐私政策》以及其他任何相关的保密和安全措施来处理信息。
            <br />4.2 转让 <br />4.2.1
            随着本平台业务的持续发展，本平台有可能进行合并、收购、资产转让或类似的交易，而用户的信息有可能作为此类交易的一部分而被转移。本平台会要求新的持有用户信息的公司、组织继续受本《隐私政策》的约束，否则,本平台将要求该公司、组织重新向用户征求授权同意。
            <br />4.2.2 在获得用户的明确同意后，本平台会向其他方转让用户的信息。
            <br />4.3
            披露。本平台仅会在以下情况下，且采取符合业界标准的安全防护措施的前提下，才会披露用户的信息：
            <br />4.3.1
            根据用户的需求，在用户明确同意的披露方式下披露用户所指定的信息；
            <br />4.3.2
            根据法律、法规的要求、强制性的行政执法或司法要求所必须提供用户信息的情况下，本平台可能会依据所要求的信息类型和披露方式披露用户的信息。在符合法律法规的前提下，当本平台收到上述披露信息的请求时，本平台会要求接收方必须出具与之相应的法律文件，如传票或调查函。本平台坚信，对于要求本平台提供的信息，应该在法律允许的范围内尽可能保持透明。本平台对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
            <br />
            <br />五、 用户信息的保留、储存 <br />5.1
            本平台会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止用户的信息遭到未经授权的访问使用、修改,避免数据的损坏或丢失。网络服务采取了多种加密技术，例如在某些服务中，本平台将利用加密技术来保护用户的信息，采取加密技术对用户的信息进行加密保存，并通过隔离技术进行隔离。
            在信息使用时，例如信息展示、信息关联计算，本平台会采用多种数据脱敏技术增强信息在使用中安全性。采用严格的数据访问权限控制和多重身份认证技术保护信息，避免数据被违规使用。
            <br />5.2
            本平台通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范信息的存储和使用。本平台通过信息接触者保密协议、监控和审计机制来对数据进行全面安全控制。
            <br />5.3
            本平台仅允许有必要知晓这些信息的员工、合作伙伴访问用户的信息，并为此设置了严格的访问权限控制和监控机制。本平台同时要求可能接触到用户的信息的所有人员履行相应的保密义务。如果未能履行这些义务，可能会被追究法律责任或被中止与我方的合作关系。
            <br />5.4 本平台会采取一切合理可行的措施，确保未收集无关的信息。
            <br />5.5
            互联网并非绝对安全的环境，而且电子邮件、即时通讯、社交软件或其他服务软件等与其他用户的交流方式无法确定是否完全加密，本平台建议用户使用此类工具时请使用复杂密码，并注意保护用户的信息安全。
            <br />5.6
            互联网环境并非百分之百安全，本平台将尽力确保或担保用户发送给本平台的任何信息的安全性。如果本平台的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致用户的合法权益受损，本平台将承担相应的法律责任。
            <br />5.7 安全事件处置 <br />5.7.1
            在通过本平台的服务与第三方进行沟通或购买商品及服务时，用户不可避免的要向交易对方或潜在的交易对方披露自己的信息，如联络方式或者邮政地址等。请用户妥善保护自己的信息，仅在必要的情形下向他人提供
            <br />5.7.2
            为应对信息泄露、损毁和丢失等可能出现的风险，本平台制定了多项制度，明确安全事件、安全漏洞的分类分级标准及相应的处理流程。本平台也为安全事件建立了专门的应急响应团队，按照安全事件处置规范要求，针对不同安全事件启动安全预案，进行止损、分析、定位、制定补救措施、联合相关部门进行溯源和打击。
            <br />5.7.3
            在不幸发生信息安全事件后，本平台将按照法律法规的要求，及时向用户告知：安全事件的基本情况和可能的影响、本平台已采取或将要采取的处置措施、用户可自主防范和降低风险的建议、对用户的补救措施等。本平台同时将及时将事件相关情况以电话通知等方式告知用户，难以逐一告知信息主体时，本平台会采取合理、有效的方式发布公告。同时，本平台还将按照监管部门要求，主动上报信息安全事件的处置情况。
            <br />5.8
            请用户理解，由于技术的限制以及风险防范的局限，即便本平台已经尽量加强安全措施，也无法始终保证信息百分之百的安全。用户需要了解，用户接入本平台的服务所用的系统和通讯网络，有可能因本平台可控范围外的情况而发生问题。
            <br />六、 用户信息保护 <br />6.1
            保护用户（特别是未成年人）的隐私是星瀛科技的一项基本政策，因此，若父母（监护人）希望未成年人（尤其是十岁以下子女）得以使用本服务，必须以父母（监护人）名义申请注册，在接受本服务时，应以法定监护人身份加以判断本服务是否符合于未成年人。
            <br />6.2
            在不透露单个用户隐私资料的前提下，星瀛科技有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。尽管对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。
            <br />6.3
            未经用户许可星瀛科技不得向任何第三方公开或共享用户注册资料中的姓名、个人有效身份证件号码、联系方式、家庭住址等个人身份信息，但下列情况除外：
            <br />6.3.1 用户或用户监护人授权星瀛科技披露的； <br />6.3.2
            有关法令要求星瀛科技披露的； <br />6.3.3
            司法机关或行政机关基于法定程序要求星瀛科技提供的； <br />6.3.4
            星瀛科技为了维护自己合法权益而向用户提起诉讼或者仲裁时； <br />6.3.5
            应用户监护人的合法要求而提供用户个人身份信息时； <br />6.3.6
            为维护社会公众的利益。
            <br />
            <br />七、 用户信息管理 <br />7.1 访问、更新和删除 <br />7.1.1
            本平台鼓励用户更新和修改用户的信息以使其更准确有效。用户能通过本平台的服务访问用户的信息，并根据对应信息的管理方式自行完成或要求本平台进行修改、补充和删除。本平台将采取适当的技术手段，尽可能保证用户可以访问、更新和更正自己的信息或使用本平台的服务时提供的其他信息。
            <br />7.1.2
            在访问、更新、更正和删除前述信息时，本平台可能会要求用户进行身份验证，以保障信息安全。对于通过COOKIES和WEB
            BEACON收集的用户的信息，本平台还在本《隐私政策》第三条“COOKIES、日志档案和WEB
            BEACON”部分说明了向用户提供的选择机制。 <br />7.2 公开与分享
            <br />7.2.1
            本平台的多项服务可让用户不仅与用户的社交网络、也与使用该服务的所有用户公开分享用户的相关信息，例如，用户在服务中所上传或发布的信息、用户对其他人上传或发布的信息作出的回应，通过电子邮件或在服务中不特定用户可见的公开区域内上传或公布用户的个人信息，以及包括与这些信息有关的位置数据和日志信息。只要用户不删除用户所公开或共享的信息，有关信息可能一直留存在公众领域；即使用户删除共享信息，有关信息仍可能由其他用户或不受本平台控制的第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公众领域保存。如用户将信息通过上述渠道公开或共享，由此造成用户的信息泄露，本平台不承担责任。因此，本平台提醒并请用户慎重考虑是否通过上述渠道公开或共享用户的信息。
            <br />7.3 注销 <br />7.3.1
            在符合单项服务的服务协议约定条件及国家相关法律法规规定的情况下，用户的该项服务帐号可能被注销或删除。当帐号注销或被删除后，与该帐号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或处理。
            <br />7.4 改变用户授权同意的范围 <br />7.4.1
            用户总是可以选择是否披露信息。有些信息是使用服务所必需的，但大多数其他信息的提供是由用户决定的。用户可以通过删除信息、关闭设备功能等方式改变用户授权本平台继续收集信息的范围或撤回用户的授权。
            <br />7.4.2
            当用户撤回授权后，本平台无法继续为用户提供撤回授权所对应的服务，也不再处理用户相应的信息。但用户撤回授权的决定，不会影响此前基于用户的授权而开展的信息处理。
            <br />7.5 有关敏感信息的提示 <br />7.5.1
            某些信息因其特殊性可能被认为是敏感信息，例如用户的种族、宗教、个人健康和医疗信息等，以及身份证明文件、个人生物识别信息、财产信息、行踪轨迹、未成年人的信息等。
            <br />7.5.2
            请注意，用户在服务中所提供、上传或发布的内容和信息（例如有关用户社交活动的照片或信息），可能会泄露用户的敏感信息。用户需要谨慎地考虑，是否使用服务披露用户的敏感信息。
            <br />7.5.3
            用户同意用户的敏感信息按本《隐私政策》所述的目的和方式来处理。
            <br />
            <br />八、 第三方服务
            <br />本服务可能链接至第三方提供的社交媒体或其他服务（包括网站或其他服务形式）。包括：
            <br />8.1
            用户可利用“分享”键将某些内容分享到其他服务，或用户可利用第三方服务登录本平台的服务。这些功能可能会收集用户的信息（包括用户的日志信息），并可能在用户的电脑装置COOKIES，从而正常运行上述功能；
            <br />8.2
            本平台通过广告或本平台服务的其他方式向用户提供链接，使用户可以接入第三方的服务或网站；
            <br />8.3 其他接入第三方服务的情形。 <br />8.3.1
            该等第三方社交媒体或其他服务由相关的第三方负责运营。用户使用该等第三方的社交媒体服务或其他服务（包括用户向该等第三方提供的任何信息），须受第三方自己的服务条款及信息保护声明（而非本《隐私政策》）约束，用户需要仔细阅读其条款。本《隐私政策》仅适用于本平台所收集的任何信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，而本平台对任何第三方使用由用户提供的信息不承担任何责任。
            <br />
            <br />九、 通知和送达 <br />9.1
            本协议项下所有的通知均可通过重要页面公告、电子邮件、短信或常规的信件传送等方式进行；该通知于发送之日视为已送达收件人。
            <br />
            <br />十、 免责声明 <br />10.1 星瀛科技通行证所有者不保证以下事宜：
            <br />10.1.1 本服务将符合您的要求； <br />10.1.2
            本服务将不受干扰、及时提供、安全可靠或不会出错。 <br />十一、
            拒绝提供担保 <br />11.1
            用户个人对网络服务的使用承担风险。星瀛科技对以下事宜不作任何类型的担保，不论是明确的或隐含的：
            <br />11.1.1 本协议项下星瀛科技提供的相关网络服务将符合用户的要求；
            <br />11.1.2
            本协议项下星瀛科技提供的相关服务将不受不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、电信部门原因及其他任何网络、技术、通信线路等外界或人为因素的影响；
            <br />11.1.3
            安装、复制、访问网站、充值、运行客户端软件或以其它方式使用“网络游戏”及/或接受星瀛科技提供的相关服务与任何其他软件不存在任何冲突；
            <br />11.1.4
            通过星瀛科技网站、网络游戏官方网站及其他相关网络上的链接和标签所指向的第三方的商业信誉及其提供服务的质量。
            <br />
            <br />十二、 服务变更、中断或终止 <br />12.1
            如因系统维护或升级的需要而需暂停网络服务，星瀛科技将尽可能事先进行通告。
            <br />12.2
            用户在接受星瀛科技服务时实施不正当行为的，星瀛科技有权终止对用户提供服务，该不当行为包括但不限于违约、违法、违反公序良俗、侵犯星瀛科技或任何第三方之权益等。
            <br />12.3
            用户在接受星瀛科技服务时实施本协议中有明确约定或属于星瀛科技事先明确告知的应被终止服务的禁止性行为的，星瀛科技有权终止对用户提供服务。
            <br />12.4
            用户提供虚假注册身份信息，或实施违反本协议的行为，星瀛科技采取中止措施应当通知用户并告知中止期间，中止期间应该是合理的，中止期间届满星瀛科技应当及时恢复对用户的服务。
            <br />12.5
            用户利用星瀛科技服务进行洗钱、预付卡套现、购买和销售非法取得虚拟货币等违法行为的，星瀛科技有权在不事先通知用户的情况下中止或终止部分或全部网络服务的权利。
            <br />
            <br />十三、 客户服务 <br />13.1
            如果您对星瀛科技采取的账号的限制、冻结或终止等任何措施有异议或在使用海星云的过程中有其他问题的，均可联系星瀛科技客户服务部门（service@starvictory.com），本平台会给予您必要的帮助。
            <br />
            <br />十四、 其他 <br />14.1
            您使用本平台即视为您已阅读并同意受本协议的约束。星瀛科技有权在必要时修改本协议条款。您可以在本平台的最新版本中查阅相关协议条款，星瀛科技亦会在本平台内显著地方公示。本协议条款变更后，如果您继续使用本平台，即视为您已接受修改后的协议。如果您不接受修改后的协议，应当停止使用本平台。
            <br />14.2 本协议签订地为中华人民共和国北京市海淀区。 <br />14.3
            本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）
            <br />14.4
            若您和星瀛科技之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您应同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
            <br />14.5
            本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
            <br />14.6
            本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
            <br />
            <br />（正文完） <br />特 别 声 明
            <br />鉴于：我国《合同法》第39条规定：采用格式条款订立合同的，提供格式条款的一方应当遵循公平原则确定当事人之间的权利和义务，并采取合理的方式提请对方注意免除或者限制其责任的条款，按照对方的要求，对该条款予以说明。
            <br />星瀛科技在此依法做出特别声明如下：
            <br />星瀛科技采取合理的方式提请用户注意的义务将通过如下方式实现：在本协议中星瀛科技以明确的足以引起用户注意的加重字体、斜体、下划线、颜色标记等合理方式提醒用户注意相关条款（需要强调的是，还包括用户应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”等形式用语的条款），该等条款的确认将导致用户在特定情况下的被动、不便、损失，请用户在确认同意本协议之前再次阅读上述条款。双方确认上述条款非属于《合同法》第40条规定的“免除其责任、加重对方责任、排除对方主要权利的”的条款。
            <br />用户如有任何需要说明条款的要求，请立即停止使用服务，同时立即发送邮件至本平台官方客服人员（邮箱地址：service@starvictory.com），若用户未发送内含说明条款要求的邮件至本平台官方客服人员而选择同意该协议，则双方在此确认星瀛科技已依法履行了根据用户要求对相关条款进行说明的法定义务，星瀛科技已给予用户充足的时间与充分的选择权来决定是否缔结本协议。
            <br />用户确认已经充分阅读本协议所有条款，明确理解以上协议条款的含义，完全注意并同意了本协议所有条款的合法性及有效性。
            <br />
            <br />
            <br />公司电话：010-88464460
            <br />公司注册地址：北京市海淀区西杉创意园二区18号楼-1至3层03
            <br />公司常用办公地址：北京市海淀区西杉创意园二区18号楼-1至3层03
            <br />信息保护负责人联系电话：010-88464460
          </div>
        </div>
      </main>
    </el-dialog>
    <!-- 隐私协议 end -->
    <LoginSucce ref="LoginSucce" :mobile_flag="mobile_flag"></LoginSucce>
  </main>
</template>

<script>
import yzm from '@/base/yzm.vue'
import wjmm from '@/base/wjmm.vue'
import BindWx from '@/base/BindWx.vue'
import LoginSucce from '@/base/LoginSucce.vue'
import adaption from '@/mixi/adaption'
export default {
  mixins: [adaption],
  components: {
    yzm,
    wjmm,
    BindWx,
    LoginSucce
  },
  data () {
    return {
      yzmFalse: null,
      showBack: false,
      qrShow: false,
      bLoading: false,
      bLogin1: false,
      bLogin2: false,
      bLogin3: false,
      nwxLogin: 4, // 初始  2微信扫码  3验证码  4密码  5忘记密码  6绑定微信
      form: {},
      hoved: false,
      longin: false,
      longinText: '密码登录',
      yzm_top: '验证码注册/登录',
      checkboxVal: 0
    }
  },
  watch: {
    nwxLogin (newVal, oldVal) {
      console.log(newVal, oldVal, 'wo shi 123')
    },
    bLogin1 (newVal, oldVal) {
      if (newVal) {
        this.qrShow = false
        this.bLogin1 = true
        this.fwx()
      }
    },
    '$store.state.GlobalLogin': function () {
      this.bLogin1 = false
      this.yzm_top = '密码登录'
    }
  },
  mounted () {
    this.$on('global:openLoginSucce', () => {
      this.nwxLogin = 1
      this.bLogin1 = this.bLogin2 = false
      this.$refs.LoginSucce.bLogin1 = true
      console.log(this.nwxLogin)
    })
    // 如果是新用户 则 access_token，open_id 有值， token 为空
    // 在随用户资料把access_token，open_id 发到后台。
    //  如果已经绑定过微信，则access_token，open_id 为空， token有值， 这就是我们自己的token
    if (this.$route.query.access_token && document.cookie.indexOf('user_sess') < 0) {
      console.log(this.$route.query.access_token, document.cookie.indexOf('user_sess'))

      let that = this
      setTimeout(() => {
        that.bLogin1 = true
        this.checkboxVal = 1 // 隐藏登录遮罩提示框
        that.nwxLogin = 6
      }, 200)
      console.log('显示微信绑定框', this.nwxLogin)
    }
    if (this.$route.query.token) {
      this.$cookieStore.setCookie(
        'user_sess',
        this.$route.query.token,
        2590000
      )
      this.$router.push({})
      console.log('登陆后')
    }
    if (this.$route.query.invtecode != undefined) {
      let that = this
      setTimeout(() => {
        that.bLogin1 = true
        that.nwxLogin = 3
      }, 200)
    }
  },
  methods: {
    longinMS () {
      this.yzmFalse = false
      this.$nextTick(() => {
        this.$refs.yzm.hiddwxzi()
      })
      if (this.longin == true) {
        this.longin = false
        this.longinText = '密码登录'
        this.switchLogin(3)
        this.yzmFalse = false
        this.yzm_top = '验证码注册/登录'
      } else if (this.longin == false) {
        this.longin = true
        this.longinText = '验证码注册/登录'
        this.switchLogin(4)
        this.yzm_top = '密码登录'
        this.yzmFalse = true
      }
    },
    FatherIndex () {
      this.longin = true
      this.longinText = '验证码注册/登录'
      this.switchLogin(4)
      this.yzmFalse = true
      this.yzm_top = '密码登录'
    },
    enter () {
      this.hoved = true
    },
    leave () {
      this.hoved = false
    },
    loginClose () {
      this.bLogin1 = false
      this.bLogin2 = false
    },
    back () {
      console.log(10)
      if (this.nwxLogin == 6 && this.$refs.BindWx.showPass == false) {
        return this.$refs.BindWx.showPass = true
      }
      this.qrShow = false
      this.nwxLogin = 1
    },
    switchLogin (parm) {
      this.qrShow = false
      this.nwxLogin = parm
      if (parm === 4) {
        this.$nextTick(() => {
          this.$refs.yzm.sms_login()
        })
      } else {
        this.$nextTick(() => {
          // console.log(this.$refs)
          // this.$refs.yzm.pass_login()
        })
      }
    },
    init () {
      var obj = new WxLogin({
        self_redirect: false,
        id: 'login_container',
        appid: 'wx737bc9eb54d88878',
        scope: 'snsapi_login',
        redirect_uri: encodeURIComponent(
          'https://www.haixingcloud.com:8000/api/sns/callback'
        ),
        state: 'wechat',
        style: 'white',
        href: 'data:text/css;base64,QGNoYXJzZXQgInV0Zi04IjsKaWZyYW1le3dpZHRoOiAyNTBweDt9Ci5pbXBvd2VyQm94IC5xcmNvZGV7IHdpZHRoOiAyNTBweDt9Ci53YWl0aW5nLnBhbmVsQ29udGVudHt3aWR0aDogMjUwcHg7fQouaW1wb3dlckJveCAudGl0bGUgewogICAgdGV4dC1hbGlnbjogY2VudGVyOwogICAgZm9udC1zaXplOiAyMHB4OwogICAgdGV4dC1pbmRlbnQ6IC00N3B4Owp9Ci5pbXBvd2VyQm94IC5pbmZvIHsKICAgIHdpZHRoOiAyNTBweDsKICAgIG1hcmdpbjogMCBhdXRvOwp9Ci5pbXBvd2VyQm94IC5zdGF0dXNfdHh0IHsKICAgIGRpc3BsYXk6IGlubGluZS1ibG9jazsKICAgIHZlcnRpY2FsLWFsaWduOiBtaWRkbGU7CiAgICBtYXJnaW4tcmlnaHQ6IC0xNHB4Owp9'
      })
    },
    fwx () {
      this.$nextTick(() => {
        setTimeout(() => {
          this.init()
        }, 200)
      })
    }

  }
}
</script>

<style lang="scss" scoped>
.wxActive {
  color: #fff;
  background: #00c801;
}
.login-main {
  width: 272px;
  margin: 0 auto;
  position: relative;
  .login-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;
    width: 100%;
    height: 98%;
    background: #000000eb;
    z-index: 999;
    border-radius: 5px;
    .text1 {
      p {
        padding: 0;
        margin: 6px 0;
      }
      width: 80%;
      margin: 50% auto 0;
      color: #fff;
      font-size: 16px;
      text-align: center;
    }
  }
}
.p-logins1 .footer {
  width: 272px;
  margin: 0 auto;
  text-align: left;
  position: static;
  font-size: 13px;
  display: flex;
  align-items: center;
  .checked-xy {
    padding: 0;
    width: 14px;
    height: 14px;
    display: inline-block;
    line-height: 14px;
    margin: 0 5px 0 0 !important;
  }
  a {
    display: block;
  }
}
.title.wx-bg {
  text-indent: 6px;
  margin-bottom: 5px;
  height: 60px;
  background: url("/static/wx-bg.png") no-repeat center 9px;
  background-size: 246px 40px;
}

.active {
  cursor: pointer;
  font-size: 18px;
  font-family: NotoSansHans-Black, NotoSansHans;
  font-weight: 900;
  color: rgba(255, 255, 255, 1);
  letter-spacing: 1px;
}
.el-dialog__body {
  margin-left: 30px;
  padding: 0 !important;
}
.longin_fa {
  display: inline-block;
}
.longin {
  // display: inline-block;
  cursor: pointer;
  user-select: none;
  color: white;
  margin-left: 34px;
  margin-top: -5px;
  text-align: center;
  padding: 3px 12px;
  border: 1px solid transparent;
  border-radius: 3px;
}
.longin:hover {
  background-color: #6767676e;
  // border: 1px solid #fff6;
}
.p-logins1 .back {
  display: none;
}
.yzm_top {
  width: 100%;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/base/newLogin.vue